import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PatientFormResponse } from '@pixacare/dtos';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DepositHttpService {
  private readonly httpClient = inject(HttpClient);

  getForms(): Observable<PatientFormResponse[]> {
    return this.httpClient.get<PatientFormResponse[]>(`${environment.apiBaseUrl}/Deposit/forms?forms=true`);
  }
}
